module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.index != null) ? _c('span', [_c('div', {
    staticClass: "ui dimmer modals page transition visible active"
  }, [_c('div', {
    staticClass: "ui basic modal popupModal transition visible active"
  }, [_c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.cancel_text) ? _c('div', {
    class: _vm.cancel_class,
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cancel_text) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.confirm_class,
    on: {
      "click": function($event) {
        return _vm.$emit('delete', _vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n          " + _vm._s(_vm.confirm_text) + "\n        ")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-951402ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupModal.vue
// module id = 505
// module chunks = 1